import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className='About'>
      <h2>&lt;About Me&gt;</h2>
      <div className='para'>
        <p>
          Hi, I'm <strong>Jason Zheng</strong> — a passionate Computer Science graduate from the University at Buffalo, 
          currently pursuing my Master's degree at NYU. I specialize in <strong>full-stack development</strong> and 
          enjoy building scalable, user-centered applications that solve real problems.
        </p>

        <p>
          At <strong>The Musicians Club</strong>, I redesigned their Shopify homepage and engineered a custom-coded 
          menu system to efficiently navigate 30,000+ products. I also developed a musician-focused forum on Wix and 
          helped implement a tutoring system for online lessons.
        </p>

        <p>
          My university projects showcase my full-stack capabilities. I built <strong>Sprint Spark</strong>, a workflow 
          automation platform that unifies Jira, GitHub, and Confluence with a Django REST backend and React frontend. 
          I owned the AWS deployment, implemented CI/CD pipelines, and developed features like automated Jira story 
          creation and an AI chatbot for Confluence documentation.
        </p>

        <p>
          I also led <strong>Team Up</strong>, a bilingual gaming forum that received an honorable mention at Demo Day. 
          After university support ended, I independently redesigned the backend with Django and successfully redeployed 
          the entire project on Vercel and Railway.
        </p>

        <p>
          My side projects include <strong>Power Chess</strong>, a Chinese chess website with multiplayer functionality 
          and optimized state management, and <strong>Motif-Song</strong>, a music discovery platform deployed on AWS 
          with PostgreSQL and the Spotify API.
        </p>

        <p>
          My technical toolkit includes <strong>Python, JavaScript, Java</strong>, and frameworks like <strong>React, 
          Django, Spring Boot, PostgreSQL, Docker, AWS, and CI/CD pipelines</strong>. I'm always eager to learn new 
          technologies and collaborate on projects that create meaningful impact.
        </p>
      </div>
    </div>
  );
};

export default About;